import React, { Component } from 'react';
import HavenNav from '../HavenNav/HavenNav';
import ReferralsPage from './ReferralsPage/ReferralsPage'

class HavenReferrals extends Component {
    state = {

    }

  
    render() {
        
        return ( 
            <div className="dash-wrapper">
                <HavenNav referralAdded={this.referralAdded}/>
                <ReferralsPage form_heading={this.state.form_heading} />    
            </div>
        )
    }
}

export default HavenReferrals;




// WEBPACK FOOTER //
// ./src/Components/Pages/MyHaven/HavenReferrals/HavenReferrals.jsx